import { Module } from 'vuex';

export const MAX_CS = 4;
export const MIN_CS = 1;
const getInitialState = () => ({
  tiers: {
    tier0: 1,
    tier1: 1,
    tier2: 1,
    tier3: 1,
    minimal: MIN_CS,
    maximal: MAX_CS,
  },
  loading: false
});

export default new class implements Module<any, any> {
  name = 'nvme';
  namespaced = true;
  state = getInitialState();
  mutations = {
    FETCH_SUCCESS(state, data) {
      state.tiers = data;
      if (data.maximal > MAX_CS) {
        state.tiers.maximal = MAX_CS;
      }
    },
    LOADING_START(state) {
      state.loading = true;
    },
    LOADING_END(state) {
      state.loading = false;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  };

  getters = {
    loading: state => state.loading,
    tiers: state => state.tiers,
  };

  actions: CommonActionTree<any> = {
    FETCH({ commit }) {
      commit('LOADING_START');
      return this.$api.get('/api/v2/cses/services-per-disk/')
        .then((response) => {
          commit('FETCH_SUCCESS', response.data);
          commit('LOADING_END');
          return response;
        })
        .catch((error) => {
          commit('LOADING_END');
          throw error;
        });
    },
    SAVE({ commit }, tiers) {
      commit('LOADING_START');

      return this.$api.put('/api/v2/cses/services-per-disk/', tiers)
        .then((response) => {
          commit('FETCH_SUCCESS', response.data);
          commit('LOADING_END');
          return response;
        })
        .catch((error) => {
          commit('LOADING_END');
          throw error;
        });
    }
  };
}();
